import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationCalendar = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationCalendar',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70284)",
    fillRule: "evenodd",
    d: "M84 93.5H16c-5.52 0-10-4.48-10-10v-68c0-2.21 1.79-4 4-4h80c2.21 0 4 1.79 4 4v68c0 5.52-4.48 10-10 10Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1DA3AA",
    fillRule: "evenodd",
    d: "M37.77 93.5H16c-5.52 0-10-4.48-10-10V59.75s5.49 14.33 12.8 21.74c7.31 7.43 18.97 12.01 18.97 12.01Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70284)",
    fillRule: "evenodd",
    d: "M37.77 93.5C28.88 88.72 31 68.87 31 68.87s-18.41 5.9-25-8.74c0 0-.35 9.74 11.19 21.74 11.54 12 20.58 11.63 20.58 11.63Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70284)",
    fillRule: "evenodd",
    d: "M94 27.43H6V15.5c0-2.21 1.79-4 4-4h80c2.21 0 4 1.79 4 4v11.93Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#E36A98",
    fillRule: "evenodd",
    d: "M70.36 6.5a3.45 3.45 0 0 0-3.45 3.45v5.11a3.45 3.45 0 0 0 6.9 0V9.95a3.45 3.45 0 0 0-3.45-3.45ZM29.55 6.5a3.45 3.45 0 0 0-3.45 3.45v5.11a3.45 3.45 0 0 0 6.9 0V9.95c0-1.91-1.54-3.45-3.45-3.45Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70284",
    x1: 71.114,
    x2: 20.22,
    y1: 13.408,
    y2: 102.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.02,
    stopColor: "#B2F7FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.183,
    stopColor: "#99EDF5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.918,
    stopColor: "#2CC0CA"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70284",
    x1: 7.11,
    x2: 23.785,
    y1: 96.178,
    y2: 74.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.285,
    stopColor: "#2CC0CA"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.829,
    stopColor: "#B2F7FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#C9FAF9"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70284",
    x1: 49.696,
    x2: 50.617,
    y1: 35.132,
    y2: -6.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.285,
    stopColor: "#E36A98"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#C9FAF9"
  }))));
};
ColoredIllustrationCalendar.displayName = 'ColoredIllustrationCalendar';
export default withProvisionalOverrideFromContext(ColoredIllustrationCalendar);
//# sourceMappingURL=index.js.map